'use client'

import { useEffect } from 'react'
import clsx from 'clsx'
import { useSetAtom } from 'jotai'
import { loadOneTrustAtom } from '@/components/CookieConsent/OneTrustAtom'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import type { GridColumnsField, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { ConditionalWrapper } from 'ui/src/components/ConditionalWrapper'
import { preferenceButton } from './CookiePreferenceButtonBlock.css'

export type CookiePreferenceButtonBlockProps = SbBaseBlockProps<{
  buttonLabel: string
  layout?: GridColumnsField
}>

export const CookiePreferenceButtonBlock = ({ blok, nested = false }: CookiePreferenceButtonBlockProps) => {
  const setLoadOneTrust = useSetAtom(loadOneTrustAtom)

  // OneTrust binds the click handler to elements with class `ot-sdk-show-settings`,
  // so we need to ensure the script is loaded for the button to actually do anything.
  useEffect(() => {
    setLoadOneTrust(true)
  }, [setLoadOneTrust])

  return (
    <ConditionalWrapper
      condition={!nested}
      wrapWith={(children) => (
        <GridLayout.Root>
          <GridLayout.Content width={blok.layout?.widths ?? { _: '1' }} align={blok.layout?.alignment ?? 'center'}>
            {children}
          </GridLayout.Content>
        </GridLayout.Root>
      )}
    >
      <button
        {...storyblokEditable(blok)}
        id="ot-sdk-btn"
        type="button"
        className={clsx('ot-sdk-show-settings', preferenceButton)}
      >
        {blok.buttonLabel}
      </button>
    </ConditionalWrapper>
  )
}
CookiePreferenceButtonBlock.blockName = 'cookiePreferenceButton'
